module.exports = __webpack_public_path__ + "static/media/user.9960d83e.svg";